export var getUtcDateString = function (date) {
    var f = printDoubleDigitNumber;
    var dateString = date.getUTCFullYear() + "-" + f(date.getUTCMonth() + 1) + "-" + f(date.getUTCDate());
    var timeString = f(date.getUTCHours()) + ":" + f(date.getUTCMinutes()) + ":" + f(date.getUTCSeconds());
    return dateString + "T" + timeString;
};
export var printDoubleDigitNumber = function (num) {
    return num < 10 ? "0" + num : num.toString();
};
